module.exports = __webpack_public_path__ + "img/content5_640_15.acfb22fc.png";